import { Typography } from '@mgmresorts/wcl-lab';
import React, { useContext } from 'react';

import { Container } from '../../../components/ui/Container';
import { Logo } from '../../../components/ui/Logo';
import accountSignUpIcon from '../../../components/ui/icons/account-activated.svg';
import { useContent } from '../../../hooks/useContent';

import { BirthdayInput } from './BirthdayInput';
import { CTASection } from './CTASection';
import { CanadianOptIn } from './CanadianOptIn';
import { EmailInput } from './EmailInput';
import { ErrorSection } from './ErrorSection';
import { FirstName } from './FirstName';
import { LastName } from './LastName';
import { ManualAddressForm } from './ManualAddressForm';
import { MlifeAccountSetupContext } from './MlifeAccountSetupContext';
import { PasswordInput } from './PasswordInput';
import { PhoneNumberInput } from './PhoneNumberInput';
import { PolicyCheckbox } from './PolicyCheckbox';

export function MlifeAccountSetupForm() {
  const { showAccountActivatedScreen } = useContext(MlifeAccountSetupContext);
  const { getContentByPath } = useContent();

  if (showAccountActivatedScreen) {
    return (
      <Container height='auto'>
        <div className='identity__account-activated-page'>
          <img src={accountSignUpIcon} alt={getContentByPath('mlifeActivation.accountSetupSection.successInfo')} />
          <Typography
            variant='paragraph'
            element='p'
            className='identity__account-activated-page-info'
            testId='mlifeActivation-account-activated-info'
          >
            {getContentByPath('mlifeActivation.accountSetupSection.successInfo')}
          </Typography>
        </div>
      </Container>
    );
  }

  return (
    <Container height='auto'>
      <Logo className='identity__page-logo' />
      <Typography className='identity__page-heading' variant='h1' testId='page-title'>
        {getContentByPath('mlifeActivation.accountSetupSection.title')}
      </Typography>
      <Typography variant='paragraph'>{getContentByPath('mlifeActivation.accountSetupSection.subtitle')}</Typography>
      <ErrorSection />
      <EmailInput />
      <PasswordInput />
      <Typography variant='h5' className='identity__guestInfo-title'>
        {getContentByPath('mlifeActivation.accountSetupSection.fields.guestInfo.title')}
      </Typography>
      <FirstName />
      <LastName />
      <BirthdayInput />
      <PhoneNumberInput />
      <Typography variant='h5' className='identity__address-title'>
        {getContentByPath('mlifeActivation.accountSetupSection.fields.address.title')}
      </Typography>
      <ManualAddressForm />
      <CanadianOptIn />
      <PolicyCheckbox />
      <CTASection />
    </Container>
  );
}

MlifeAccountSetupForm.displayName = 'MlifeAccountSetupForm';
